import { queries } from "@corpuscomplete/core/zero";
import { ListPage } from "@corpuscomplete/web/modules/common/list/pages/list";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/personal/lists/$id")({
  component: () => {
    const { id } = Route.useParams();
    return <ListPage id={id} />;
  },
  loader: async ({ context, params }) => {
    void context.zero?.run(queries.list.details({ id: params.id }));
  },
});
